// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2019 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.theia-progress-bar-container {
  width: 100%;
  height: 2px;
}

.theia-progress-bar {
  background-color: var(--theia-progressBar-background);
  height: 2px;
  width: 3%;
  animation: progress-animation 1.3s 0s infinite
    cubic-bezier(0.645, 0.045, 0.355, 1);
}

@keyframes progress-animation {
  0% {
    margin-left: 0%;
    width: 3%;
  }
  60% {
    margin-left: 45%;
    width: 20%;
  }
  100% {
    margin-left: 99%;
    width: 1%;
  }
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@theia/core/src/browser/style/progress-bar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,SAAS;EACT;wCACsC;AACxC;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":["/********************************************************************************\n * Copyright (C) 2019 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.theia-progress-bar-container {\n  width: 100%;\n  height: 2px;\n}\n\n.theia-progress-bar {\n  background-color: var(--theia-progressBar-background);\n  height: 2px;\n  width: 3%;\n  animation: progress-animation 1.3s 0s infinite\n    cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n@keyframes progress-animation {\n  0% {\n    margin-left: 0%;\n    width: 3%;\n  }\n  60% {\n    margin-left: 45%;\n    width: 20%;\n  }\n  100% {\n    margin-left: 99%;\n    width: 1%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
